import React, { useContext, useEffect, useState } from 'react';
import { Typography, Box, Button, Chip, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { getRegisterEvents } from '../../../Utils/apiService';
import routes from '../../../Utils/routes';
import AddIcon from '@mui/icons-material/Add';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import moment from 'moment';
import StatusChip from '../../../Components/AppChip';

const EventsContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    state: { user }
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [createdEvents, setCreatedEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    getRegisterEvents(userData?.applicantId)
      .then((res) => {
        const data = JSON.parse(res.data);
        const createdByMeEvents = data?.filter((item: any) => item.createdbyMe === true) || [];
        setCreatedEvents(createdByMeEvents);

        console.log(createdByMeEvents, "skfnkdjfn");

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [userData?.applicantId]);

  const handleHostEvent = () => {
    navigate('/events/host event');
  };

  const handleSetupFeedbackForm = (eventId: string) => {
    navigate(`/events/host event?eventId=${eventId}`);
  };

  const renderEventCard = (event: any) => {
    const isRejected = event.isRejected;
    const isApproved = event.isApproved;
    const isUpcoming = event.isUpcoming;
    const isInReview = !isRejected && !isApproved && !isUpcoming;

    return (
      <Box
        key={event.Id}
        sx={{
          p: { xs: 2, sm: 3 },
          mb: 2,
          borderRadius: '8px',
          backgroundColor: '#f9f9f9',
          border: '1px solid #E6E6E8',
          position: 'relative'
        }}
      >
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} md={4} sx={{ textAlign: 'left' }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: '14px', sm: '16px', md: '18px' },
                fontWeight: 600,
                mb: 1,
                lineHeight: 1.3
              }}
            >
              {event.eventTitle}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: { xs: '11px', sm: '12px', md: '13px' }, color: '#666', lineHeight: 1.4 }}
            >
              Event type: {event.eventType || ''} | {event.sessionType || ''}
            </Typography>
          </Grid>

          <Grid item xs={12} md={5} sx={{ textAlign: 'left', mt: { xs: 1, md: 0 } }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '20px 1fr',
                columnGap: 1,
                rowGap: 1,
                alignItems: 'start'
              }}
            >
              <AccessTimeIcon sx={{ fontSize: { xs: '14px', sm: '16px' }, color: '#666', mt: '2px' }} />
              <Typography variant="body2" sx={{ fontSize: { xs: '11px', sm: '12px', md: '13px' }, color: '#666' }}>
                {moment(event.startDate).format('DD MMM YY, h:mm a')} - {moment(event.endDate).format('h:mm a')} IST
              </Typography>

              <LocationOnIcon sx={{ fontSize: { xs: '14px', sm: '16px' }, color: '#666', mt: '2px' }} />
              <Typography
                variant="body2"
                sx={{ fontSize: { xs: '11px', sm: '12px', md: '13px' }, color: '#666', wordBreak: 'break-word' }}
              >
                {event.location || 'Location: TBD'}
              </Typography>

              <PeopleIcon sx={{ fontSize: { xs: '14px', sm: '16px' }, color: '#666', mt: '2px' }} />
              <Typography variant="body2" sx={{ fontSize: { xs: '11px', sm: '12px', md: '13px' }, color: '#666' }}>
                {event.maximumNumberofParticipants
                  ? `Maximum number of participants: ${event.maximumNumberofParticipants}`
                  : `Total participants: ${event.maxParticipants || 50}`}
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
              mt: { xs: 1, md: 0 }
            }}
          >
            {(isApproved || isUpcoming) && (
              <Button
                variant="contained"
                size="small"
                color="info"
                onClick={() => handleSetupFeedbackForm(event.Id)}
                fullWidth
                sx={{
                  textTransform: 'none',
                  fontSize: { xs: '11px', sm: '12px', md: '13px' },
                  maxWidth: { md: '220px' }
                }}
              >
                Setup feedback form
              </Button>
            )}
          </Grid>

          {/* <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'left', display: { xs: 'none', md: 'block' } }}>
          </Grid> */}
        </Grid>

        {isRejected && (
          <Box sx={{ mt: 2 }}>
            <Box sx={{
              backgroundColor: '#FFF4F4',
              borderRadius: '4px',
              p: { xs: 1.5, sm: 2 },
              position: 'relative',
              textAlign: 'left'
            }}>
              <Typography variant="subtitle2" sx={{ color: '#F44336', fontWeight: 600, mb: 1, fontSize: { xs: '13px', sm: '14px' } }}>
                Venue not available
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', fontSize: { xs: '12px', sm: '14px' } }}>
                {event.rejectionReason || 'The requested venue is not available on the selected dates'}
              </Typography>
            </Box>
          </Box>
        )}

        {isInReview && (
          <StatusChip
            label="In review"
            // size="small"
            color='In Review'
            sx={{
              position: 'absolute',
              borderRadius: ' 0px 0px 0px 12px',
              padding: '4px',
              color: '#695113',
              background: "#FEEBBE",
              top: 0,
              right: 0,
              border: 'none !important'

            }}
          />
        )}
        {isUpcoming && (
          <StatusChip
            label="Upcoming"
            // size="small"
            color='In Review'
            sx={{
              position: 'absolute',
              borderRadius: ' 0px 0px 0px 12px',
              padding: '4px',
              color: '#2245B5',
              background: "#EAEFFF",
              top: 0,
              right: 0,
              border: 'none !important'

            }}
          />

        )}
        {isApproved && (
          <StatusChip
            label="Approved"
            // size="small"
            color='In Review'
            sx={{
              position: 'absolute',
              borderRadius: ' 0px 0px 0px 12px',
              padding: '4px',
              color: '#183C19',
              background: "#C1DCC3",
              top: 0,
              right: 0,
              border: 'none !important'

            }}
          />
        )}
        {isRejected && (
          <StatusChip
            label="Reason for a rejection"
            // size="small"
            color='In Review'
            sx={{
              position: 'absolute',
              borderRadius: ' 0px 0px 0px 12px',
              padding: '4px',
              color: '#962121',
              background: "#F1BFBF",
              top: 0,
              right: 0,
              border: 'none !important'

            }}
          />
        )}
      </Box>
    );
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, backgroundColor: 'white', borderRadius: '8px' }}>
      <Box>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <Typography>Loading...</Typography>
          </Box>
        ) : createdEvents.length === 0 ? (
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            py: 4,
            textAlign: 'center'
          }}>
            <EventIcon sx={{ fontSize: 60, color: '#ccc', mb: 2 }} />
            <Typography variant="body1" sx={{ mb: 2, color: '#666' }}>
              You haven't created any events yet
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleHostEvent}
              sx={{
                borderRadius: '6px',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500
              }}
            >
              Host Your First Event
            </Button>
          </Box>
        ) : (
          <>
            {createdEvents.map((event) => renderEventCard(event))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default EventsContent;
